export default "__VITE_ASSET__Doyb7ocy__"